module.exports = __webpack_public_path__ + "static/media/card_image_1.739576e5.png";